import React from 'react';
import styled from 'styled-components';

const FooterDiv = styled.div`
                      font-size:12px;
                      background: #000;
                      padding-top:200px;
                      padding-bottom:6px;
                      color:#fff;
                      text-align:center;
                    
`;

function Footer() {
  return (   
      <div className="container">
        <FooterDiv>
          <div className="row">
            <div className="col-12">
            © 2020 Arq | Privacy Policy 
            </div>
          </div>
        </FooterDiv>
      </div>
   
  );
}

export default Footer;